import { IConversationMessage, UserAvatar } from '@diana/core';
import { ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { Fragment } from 'react';
import { Status } from '../DrawerTabs/Workflow/Status';

export interface ICommentsUserInfoProps {
  message: IConversationMessage;
}

export function CommentsUserInfo(props: ICommentsUserInfoProps) {
  const { message } = props;

  return (
    <Fragment>
      <ListItemAvatar sx={{ minWidth: 'initial', marginRight: 1 }}>
        <UserAvatar
          user={{
            id: message.fromUserId,
            displayName: message.fromUserName,
          }}
          sx={{ width: '32px', height: '32px', fontSize: '14px' }}
        />
      </ListItemAvatar>
      <ListItemText
        sx={{ m: 0 }}
        primary={
          <Typography component="p" variant="body1" sx={{ fontWeight: 500 }}>
            {message.fromUserName}
          </Typography>
        }
        secondary={
          <Typography component="div" variant="body1">
            <Status isoDateTime={message.timestamp.toString()} />
          </Typography>
        }
      />
    </Fragment>
  );
}
